import { z } from "zod";

/**
 * Generate API Key endpoint schemas
 *
 * POST /api/deployments/:id/generate-api-key
 *
 * Generates a JWT-based API key for API-type deployments.
 * The key contains the deploymentId and organizationId.
 */

export const GenerateApiKeyPathVarsSchema = z.object({
  id: z.string().uuid()
});

export const GenerateApiKeyResponseSchema = z.object({
  apiKey: z.string().min(1)
});
